<script>
export default {
  props: {
    code: {
      type: String,
      default: ''
    },
  }
}
</script>

<template>
  <p v-if="code">{{ $t('modal.content.roster_code') }} <b>{{ code }}</b> {{ $t('modal.content.copied_to_clipboard') }}</p>
</template>
